import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import { type DynamicZoom } from "Interfaces";

const initialState: DynamicZoom = {
	enabled: false,
	duration: "",
	threshold: "",
	zoomLevel: 10,
	analytics: false,
	alarmIn: false,
	motion: false
};

const setDynamicZoomReducer = (state: DynamicZoom, action: PayloadAction<DynamicZoom>) => {
	return action.payload;
};

const getDynamicZoom = (state: DynamicZoom) => {
	return state;
};

const dynamicZoomSlice = createAppSlice({
	name: "dynamicZoom",
	initialState,
	reducers: {
		setDynamicZoomAction: setDynamicZoomReducer
	},
	selectors: {
		selectDynamicZoom: getDynamicZoom
	}
});

export const { setDynamicZoomAction } = dynamicZoomSlice.actions;
export const { selectDynamicZoom } = dynamicZoomSlice.selectors;

export default dynamicZoomSlice;
